module.exports = __webpack_public_path__ + "static/media/logo-element.7cc24467.png";